// extracted by mini-css-extract-plugin
module.exports = {"image":"SingleBlock__image___3tVwB","content":"SingleBlock__content___je_UE layout__margin-auto___16OST"};